// @ts-strict-ignore
import { Component, OnInit } from '@angular/core';
import { ReportVO } from '@project/model/vo/report.vo';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { LocaleResourceManager } from '@shared/manager/locale-resource.manager';
import { SelectProjectReportService } from '../service/select-project-report.service';
import { ProjectNavigationPresenter } from '@project-navigation/project-navigation.presenter';

@Component({
  standalone: false,
  selector: 'select-project-for-csv',
  templateUrl: './select-project-for-csv.component.html',
})
export class SelectProjectForCSVComponent implements OnInit {

  public selectedItem: string;

  public readonly items: string[] = [
    'selectProjectForCSVExportPopup.label.export_current_project',
    'selectProjectForCSVExportPopup.label.export_saved_projects',
  ];

  public constructor(
    private bsModalRef: BsModalRef,
    private projectNavigationPresenter: ProjectNavigationPresenter,
    private selectProjectReportService: SelectProjectReportService,
    private localeResourceManager: LocaleResourceManager
  ) {}

  ngOnInit(): void {
    this.selectedItem = this.items[0];
  }

  public close(): void {
    this.bsModalRef.hide();
  }

  public next(): void {
    if (this.selectedItem === this.items[0]) {
      this.selectProjectReportService.openProjectReportPopup(ReportVO.TYPE_CSV);
    } else {
      this.projectNavigationPresenter.openSaveCsvDialog();
    }
    this.close();
  }

  public openHELPLink(): void {
    window.open(this.localeResourceManager.getValueByKey(`helplink.csvexport`), `_blank`);
  }
}
